<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">

        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()">{{labelTitleBanner[actualLanguage]}}</h2>
            </div>


            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Static Labels -->
                    <div class="block">
                        <h2 class="block-title push">{{labelCommissionsAvailable[actualLanguage]}} : {{TotalCommissionAvailable}}$</h2>
                        <h2 class="block-title push">{{labelCommissionsSelected[actualLanguage]}} : {{TotalCommissionSelected}}$</h2>

                        <div class="col-sm-12 col-md-6">
                          <p><button @click="computeTempoCommission()" type="button" class="btn btn-success" name="button">{{labelButtonComputeSelected[actualLanguage]}}</button></p>
                        </div>
                        <div class="col-sm-12 col-md-6">
                          <p><button @click="createCommissionReport()" type="button" class="btn btn-success" name="button">{{labelButtonCreateReport[actualLanguage]}}</button></p>
                        </div>

                        <div class="col-sm-12 col-md-6">
                          <p><button @click="getCommissionsHistory()" type="button" class="btn btn-success" name="button">{{labelButtonReadHistory[actualLanguage]}}</button></p>
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <h6>{{labelHistoryLength[actualLanguage]}}</h6>
                            <input v-model="historyLength" class="form-control align-center" type="test"  placeholder="">
                        </div>

                        <spinner v-if="commissionsIsReading"></spinner>
                        <div v-else class="col-xs-12 col-md-12">

                          <div class="table-responsive push-50">
                              <table class="table table-bordered table-hover">
                                  <thead>
                                      <tr>
                                          <th class="text-center" style="width: 120px;">{{labelTabel01_Col01[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 60px;">{{labelTabel01_Col02[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 100px;">{{labelTabel01_Col03[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 100px;">{{labelTabel01_Col04[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 120px;">{{labelTabel01_Col05[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 120px;">{{labelTabel01_Col06[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for ="(commission,index) in commissionsList">
                                          <td class="text-center">{{commission.OrganizationName}}</td>
                                          <td>
                                              <p class="font-w600 push-10">{{commission.TransactionId}}</p>
                                          </td>
                                          <td class="text-center">
                                              <p class="font-w600 push-10">{{commission.TransactionAmount}}$</p>
                                              <p class="font-w600 push-10">{{commission.CommissionPourcentage}}%</p>
                                              <p class="font-w600 push-10">Com:{{commission.CommissionAmount}}$</p>
                                          </td>
                                          <td class="text-center">
                                            <i v-if="commission.PaymentReceived" class="fa fa-check-square"></i>
                                            <i v-else class="fa fa-times"></i>
                                          </td>
                                          <td class="text-center">
                                            <div v-if="commission.CommissionsReport=='ND' & commission.PaymentReceived" class="checkbox">
                                                <label for="example-checkbox1">
                                                    <input v-model="commission.FlagAddToReport" class="larger" type="checkbox" value="option1">{{labelAddToReport[actualLanguage]}}
                                                </label>
                                            </div>
                                          </td>
                                          <td class="text-center">{{commission.CommissionsReport}}</td>
                                      </tr>
                                  </tbody>
                              </table>


                          </div>

                        </div>
                    <!-- END Static Labels -->
                    </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'GroupIndex',
  props: ['organization'],
  data() {
    return {
      flagDisplayBanner : 0,
      profileIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: 'Historique de payment client', EN: 'Customer payment history'},
      labelTitleBanner: {FR: 'Transaction clients', EN: 'Customer transactions'},

      commissionsIsReading : true,
      commissionsList : [],
      historyLength : 20,

      labelCommissionsAvailable: {FR: 'Montant de commissions disponible', EN: 'Available commissions amount'},
      labelCommissionsSelected: {FR: 'Montant de commissions sélectionné', EN: 'Selected commissions amount'},
      labelButtonComputeSelected: {FR: 'Calculer montant lignes sélectionné', EN: 'Compute selected lines'},
      labelButtonCreateReport: {FR: 'Créer un rapport de commissions', EN: 'Create a commissions report'},
      labelButtonReadHistory: {FR: "Lire l'historique de transaction", EN: 'Read transaction history'},
      labelHistoryLength: {FR: "Nombre de lignes lues", EN: 'Read lines'},

      labelTabel01_Col01: {FR: 'Organisation', EN: 'Organization'},
      labelTabel01_Col02: {FR: 'Transaction', EN: 'Transaction'},
      labelTabel01_Col03: {FR: 'Montant', EN: 'Amount'},
      labelTabel01_Col04: {FR: 'Paiement reçu', EN: 'Paiement received'},
      labelTabel01_Col05: {FR: 'Ajouter au rapport', EN: 'Add to report'},
      labelTabel01_Col06: {FR: 'Rapport lié', EN: 'Linked report'},
      labelAddToReport: {FR: 'Ajouter au rapport', EN: 'Add to report'},

      TotalCommissionAvailable : 0,
      TotalCommissionSelected : 0,

      messageAlertSelectLines: {FR: 'Vous devez sélectionner des transactions (colonne AJOUTER AU RAPPORT).',
                                 EN: 'You must select transactions lines (column ADD TO REPORT)'},
      messageConfirmCreateReport: {FR: 'Vous confirmer la création du rapport de commissions?',
                                 EN: 'Confirm the commission report generation?'},

    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.getCommissionsHistory()
      this.flagDisplayBanner = ~this.flagDisplayBanner
    },

    getCommissionsHistory(){
        var requestData = {'postAction':'IntegratorGetCommissionsHistory',
                          'organizationId':this.organization.organizationId,
                          'readItems':this.historyLength}
        this.commissionsIsReading = true
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              
            if(response.data.Code=='OK'){
                this.commissionsList = response.data.CommissionsList
                this.computeTempoCommission()
                this.commissionsIsReading = false
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.commissionsIsReading = false
                  }
            })   
    },


    computeTempoCommission(){
      this.TotalCommissionAvailable = 0
      this.TotalCommissionSelected = 0
      for (var n = 0; n < this.commissionsList.length; n++) {
        if(this.commissionsList[n].PaymentReceived & this.commissionsList[n].CommissionsReport=='ND'){
          this.TotalCommissionAvailable += parseFloat(this.commissionsList[n].CommissionAmount)
        }
        if (this.commissionsList[n].FlagAddToReport){
          this.TotalCommissionSelected += parseFloat(this.commissionsList[n].CommissionAmount)
        }

      }
      this.TotalCommissionAvailable = Math.round(this.TotalCommissionAvailable*100)/100
      this.TotalCommissionSelected= Math.round(this.TotalCommissionSelected*100)/100
    },


    createCommissionReport(){
      this.computeTempoCommission()
      if(this.TotalCommissionSelected == 0){
        window.alert(this.messageAlertSelectLines[this.actualLanguage])
      }else{
        if(confirm(this.messageConfirmCreateReport[this.actualLanguage])){
            var requestData = {'postAction':'IntegratorCreateCommissionReport',
                              'organizationId':this.organization.organizationId,
                              'commissionsList':this.commissionsList}
            this.commissionsIsReading = true
            this.$store.dispatch('sessionStore/postOrganization', requestData)
                .then((response) => {
                if(response.data.Code=='OK'){
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    this.getCommissionsHistory()
                    }
                    else{
                      window.alert(response.data.PromptMessage[this.actualLanguage])
                      }
                })  
          }
        }
    },






    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// IntegratorCustomerPaymentHistory.vue?10a88da2